var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefund(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.61,
    height: 54.091,
    viewBox: "0 0 47.61 54.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refund",
    transform: "translate(-11.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(11.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M50.017,11.474l-2.609,3.352a19.571,19.571,0,1,1-10.921-4.074L32.815,14.6l2.724,2.6,5.8-6.086v0l2.6-2.727L41.212,5.8h0L35.127,0l-2.6,2.727L36.492,6.5A23.8,23.8,0,0,0,31.714,53.8a24.058,24.058,0,0,0,3.75.295A23.814,23.814,0,0,0,50.017,11.474Z",
    transform: "translate(-11.608)",
    fill: "#ff6875"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M78.824,92.819h0V90.374c2.9-.324,5.718-2.154,5.718-5.63,0-4.723-4.392-5.264-7.6-5.659-2.051-.245-3.621-.53-3.621-1.772,0-1.727,2.435-1.914,3.482-1.914a4.726,4.726,0,0,1,3.775,1.663l.164.271,3.222-1.491-.159-.325a6.359,6.359,0,0,0-4.983-3.451V69.913H75.051v2.143c-3.512.518-5.6,2.467-5.6,5.256,0,4.547,4.129,5.009,7.141,5.347,2.685.317,3.934.98,3.934,2.085,0,2.111-2.924,2.276-3.82,2.276-2,0-3.919-1-4.475-2.317l-.138-.326L68.6,85.86l.14.326a7.382,7.382,0,0,0,6.317,4.306v2.327Z",
    transform: "translate(-52.687 -50.397)",
    fill: "#ff6875"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund.2642c1ac7639914d1b51fc62b7bfd55d.svg";
export { ForwardRef as ReactComponent };